import "./Grid.scss";

import { PureComponent } from "react";
import { GridColumn as KGridColumn } from "@progress/kendo-react-grid";

import type {
  GridColumnMenuProps as KGridColumnMenuProps,
  GridColumnProps as KGridColumnProps,
} from "@progress/kendo-react-grid";

export class GridColumn extends PureComponent<GridColumnProps> {
  public static displayName = "KendoReactGridColumn";

  render() {
    const { className, ...otherProps } = this.props;
    return <KGridColumn className={`tc-grid-column ${className}`} {...otherProps} />;
  }
}

export interface GridColumnProps extends KGridColumnProps {}
export interface GridColumnMenuProps extends KGridColumnMenuProps {}
